module.exports = __webpack_public_path__ + "static/media/MORRO_logo_azul@3x.04754ddd.png";